import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import './style/app.less';

ReactDOM.render(<App/>, document.getElementById('root'));